import { render, staticRenderFns } from "./card-investment.component.vue?vue&type=template&id=4a6c7e3f&scoped=true"
import script from "./card-investment.component.vue?vue&type=script&lang=js"
export * from "./card-investment.component.vue?vue&type=script&lang=js"
import style0 from "./card-investment.component.vue?vue&type=style&index=0&id=4a6c7e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c7e3f",
  null
  
)

export default component.exports